import { api } from '../../../common/api/httpClient';
import type {
  ChangePasswordRequest,
  PortalPersonalProfile,
} from '../model/personalModels';

export const personalApi = {
  profile() {
    return api<PortalPersonalProfile>('/api/portal/profile');
  },
  changePassword(request: ChangePasswordRequest) {
    return api<void>('/api/identity/change-password', {
      method: 'POST',
      body: JSON.stringify(request),
    });
  },
};
